import request from "@utils/request";
import qs from "qs";

/*
 * 获取会员信息
 * */
export function get(memberId) {
  return request.get(`/wap/member/view/${memberId}`);
}
/*
 * 绑定微信
 * */
export function bindWX(memberId) {
  return request.post(`/wap/member/bind/${memberId}`);
}
/*
 * 充值记录
 * */
export function getRecharge(q) {
  return request.post("/wap/member/recharge", {
    pageNo: q.page,
    pageSize: q.limit,
    param: q.param,
  });
}
/*
 * 我的卡项
 * */
export function getCombo() {
  return request.get("/wap/member/combo/item");
}
/*
 * 我的优惠
 * */
export function getDiscount() {
  return request.get("/wap/member/discount/item");
}
/*
 * 我的顾问
 * */
export function getAdviser(id) {
  return request.get(`/wap/member/adviser/${id}`);
}

/*
 * 消费记录
 * */
export function getConsume(q) {
  return request.post("/wap/member/consume", {
    pageNo: q.page,
    pageSize: q.limit,
    param: q.param,
  });
}
